<template>
  <custom-dialog
    class="receive-goods-dialog"
    width="600px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    :append-to-body="true"
  >
    <div class="dialog-body">
      <div class="table-bd">
        <custom-table
          :minHeight="200"
          tableCode="service_company_receive"
          :index="true"
          @filter="filterChange"
          @sort="sortChange"
          :data="tableList"
          v-model="selectedData"
          type="checkbox"
        ></custom-table>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="closeDialog">{{$t('Common.com_close')}}</el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >{{$t('Common.com_confirm')}}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {},
  props: {},
  data() {
    return {
      tableList: [],
      selectedData: [],
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    closeDialog() {
      this.visible = false;
    },
    getTableList() {
      this.$getJSON(apis.transferOrderPreReceiveList, {
        orderId: this.model.data.orderId,
      }).then((res) => {
        this.tableList = res.data;
      });
    },
    onConfirm() {
      if (!this.selectedData.length) {
        this.$message.error(this.$t('crm_receive_goods_dialog.qxzshsb'));
        return;
      }
      const reqData = {
        orderId: this.model.data.orderId,
        deviceList: this.selectedData,
      };

      this.$postJSON(apis.transferOrderReceive, reqData, true).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
  },
  created() {},
  mounted() {
    this.getTableList();
  },
};
</script>

<style>
</style>
